import { ContextAwareCookieOptions, getContextAwareCookieOptions } from './index';

export const LOCALE_COOKIE_NAME = 'locale';
export const LOCALE_COOKIE_MAX_AGE = 60 * 60 * 24 * 7 * 4 * 12 * 100; // ~100 years

export function getLocaleCookieOptions(isEmbedded: boolean): ContextAwareCookieOptions {
  return getContextAwareCookieOptions({
    isEmbedded,
    maxAge: LOCALE_COOKIE_MAX_AGE,
  });
}
